import { faCertificate } from '@fortawesome/pro-duotone-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Typography } from '@mui/material'
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { Alert, Col, Container, Row } from 'reactstrap'
import JobAnnouncementTable from './Components/JobAnnouncement/JobAnnouncementTable'
import EligibilityTable from './Components/Eligibility/EligibilityTable'
import CustomizerContext from '../../_helper/Customizer'
// import ApplicantsTable from './Components/Applicants/ApplicantsTable'
// import FloatingTab from './Components/FloatingTab/FloatingTab'
import StepperComponent from './Components/StepperComponent/StepperComponent'
import BadgesComponent from './Components/StepperComponent/BadgesComponent'
import { useLocation } from 'react-router-dom'

const GenerateCertificationList = () => {
  const { EligibilityTableShow, ApplicantTableShow, resetGenrateGeneralAvailability, setEligibilityTableShow } = useContext(CustomizerContext);
  const announcementRef = useRef(null);
  const eligibilityRef = useRef(null);
  const applicantsRef = useRef(null);
  const [refsReady, setRefsReady] = useState(false);
  const location = useLocation();
  const { state } = location;
  const notifyCheck = useMemo(() => state?.notifyMore ? "true" : "", [state])
  const [currentStep, setCurrentStep] = useState(state?.notifyMore ? 1 : 0);



  useEffect(() => {
    if (state?.notifyMore) {
      setCurrentStep(1)
      setTimeout(() => setEligibilityTableShow(
        {
          "ANNOUNCEMENT_ID": state?.AnnouncementID
        }
      ), 200)

    }
  }, [notifyCheck])

  useEffect(() => {
    setRefsReady(false)
    setTimeout(() => {
      if (announcementRef.current || eligibilityRef.current || applicantsRef.current) {
        setRefsReady(true);
      }
    }, 0)
  }, [EligibilityTableShow, ApplicantTableShow]);

  useEffect(() => {
    return () => {
      if (!state?.notifyMore)
        resetGenrateGeneralAvailability()
    }
  }, [])
  console.log(EligibilityTableShow, 'announcementRef1221')
  const ANNOUNCEMENT_ID_Value = useMemo(() => {
    const { ANNOUNCEMENT_ID } = EligibilityTableShow
    if (ANNOUNCEMENT_ID) return ANNOUNCEMENT_ID.trim()
    return ""
  }, [EligibilityTableShow])

  const isCertListCreated = useMemo(() => {
    const status = EligibilityTableShow?.CERT_LIST_STATUS;
    return Boolean(status && status.trim() !== "");
  }, [EligibilityTableShow])

  return (
    <Container fluid={true}>
      <Row className="bg-primary rounded py-3 mb-3">
        <Col className="d-flex align-items-center gap-2">
          <FontAwesomeIcon icon={faCertificate} size="xl" />
          <Typography variant="h6">{state?.notifyMore ? "Notify More Applicants" : "Generate Certification List"}</Typography>
        </Col>
      </Row>
      <Row>
        <Col>
          <StepperComponent
            currentStep={currentStep}
            setCurrentStep={setCurrentStep}
          />
          {ANNOUNCEMENT_ID_Value && (
            <div style={{ marginTop: "15px", marginBottom: "15px" }}>
              <BadgesComponent />
            </div>
          )}

          {ANNOUNCEMENT_ID_Value && !isCertListCreated &&
            <Alert
              color="warning"
              className="mb-0 py-1 px-3"
              style={{
                fontSize: "18px",
                border: "none",
                fontWeight: 500,
                color: "#856404",
                backgroundColor: "#fff3cd",
              }}
            >
              No applicants have responded to this announcement yet. Please check the View Availability page.
            </Alert>}

          {currentStep == 0 && (
            <div id="announcement-section" ref={announcementRef}>
              <JobAnnouncementTable setCurrentStep={setCurrentStep} />
            </div>
          )}

          {EligibilityTableShow && currentStep == 1 && (
            <div id="eligibility-section" ref={eligibilityRef}>
              <EligibilityTable setCurrentStep={setCurrentStep} />
            </div>
          )}
          {/* {ApplicantTableShow && currentStep == 2 && (
              <div id="applicants-section" ref={applicantsRef}>
                <ApplicantsTable />
              </div>
            )} */}
          {/* {refsReady && (
              <FloatingTab 
                announcementRef={announcementRef} 
                eligibilityRef={eligibilityRef} 
                applicantsRef={applicantsRef} 
              />
            )} */}
        </Col>
      </Row>
    </Container>
  );
}

export default GenerateCertificationList
